import {
  i
} from "./chunk.775UL347.js";

// src/components/jb-info-box/jb-info-box.css.ts
var jb_info_box_css_default = i`.sr-only{block-size:1px;border:0;clip:rect(0, 0, 0, 0);inline-size:1px;margin:-1px;overflow:hidden;padding:0;position:absolute}:host{display:block}jb-heading{margin-block-end:var(--theme-spacing-xs)}div{border:1px solid rgba(0,0,0,0);box-sizing:border-box;padding:var(--theme-spacing-m)}.isbordered{border-color:rgba(20, 30, 85, var(--theme-opacity-20, 0.2))}.bg-royalblue-light{background-color:#e7e8ee}.bg-smoke-light{background-color:#f1f2f2}.bg-stone-light{background-color:#f7f7f2}jb-button-secondary{inline-size:100%;margin-block-start:var(--theme-spacing-lm)}@media(min-width: 960px){jb-button-secondary{inline-size:auto}}.in-text{background-color:#f7f7f2;border:0}.in-text jb-richtext{--textarea-paragraph-margin-bottom: 0}`;

export {
  jb_info_box_css_default
};
